import React from 'react'
import pic from '../images/qua2.jpg'

export default () => (
  <div className="certificate">
    <img src={pic} />
  </div>
)
